import React, {useEffect, useState} from 'react';
import AntSpin from "../../components/Ant/AntSpin/AntSpin";
import styles from './DeviceRouteSelector.module.css';
import {ReactComponent as CloseButton} from "../../assets/x.svg";
import StockLocationService from "../../services/StockLocationService";
import DropdownInput from "../DropDownInput/DropdownInput";
import { useTranslation } from 'react-i18next';

const DeviceRouteSelector =  ({user, site, dispensingOrder, onClose, onRoute}) => {
    const { t } = useTranslation("deviceRouteSelector")

    const [error, setError] = useState(null);
    const [deviceList, setDeviceList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [routingInProgress, setRoutingInProgress] = useState(false)

    useEffect(()=>{
        StockLocationService.getDispensableLocations(user, site)
            .then(devices=>{
                let arr = []
                for(let i = 0; i < devices.length; i++){
                    const device = devices[i];

                    // make sure this facility uses applicable type
                    if( (device.type.type === "BLISTER_PACKAGER" && dispensingOrder.facility.packagingMethod?.type === "BLISTER_CARD") ||
                        (device.type.type === "POUCH_PACKAGER" && dispensingOrder.facility.packagingMethod?.type === "POUCH") ||
                        (device.type.type === "ATC2_POUCH_PACKAGER" && dispensingOrder.facility.packagingMethod?.type === "POUCH") ||
                        (device.type.type === "VIAL_FILLER" && dispensingOrder.facility.packagingMethod?.type === "VIAL") ) {

                        arr.push({
                            description: device.name,
                            device: device
                        });
                    }
                }
                setDeviceList(arr);
                if(arr.length){
                    setSelectedItem(arr[0])
                }
            })
            .catch(error=>{
                setError(error);
            })

    },[user, site])

    return (
        <div className={styles.DeviceRouteSelector__overlay}>
            <div className={styles.DeviceRouteSelector__modal}>

                <header className={styles.DeviceRouteSelector__header}>
                    <div>
                        <CloseButton fill={'rgba(0,0,0,0.5)'} onClick={onClose} className={routingInProgress ? styles.DeviceRouteSelector__noDisplay : styles.DeviceRouteSelector__closeButton}/>
                    </div>
                </header>
                <div className={styles.DeviceRouteSelector__modal_body}>
                    <h1 className={routingInProgress ? `${styles.DeviceRouteSelector__h1} ${styles["DeviceRouteSelector__h1--adjustedTopMargin"]}` : styles.DeviceRouteSelector__h1}>{dispensingOrder.facility.name}</h1>
                    <div className={routingInProgress ? styles.DeviceRouteSelector__noDisplay : ""}>
                        <DropdownInput
                            placeholder={t("selectDevicePlaceholder")}
                            value={selectedItem ? selectedItem.description : ''}
                            labelName={''}
                            isEnabled={true}
                            onSelection={listItem=>{setSelectedItem(listItem)}}
                            listElements={deviceList || []}
                            maxWidth={'100%'}
                            display={''}
                            isDevices={true}
                        />
                    </div>
                </div>
                <footer>
                    <div className={routingInProgress ? styles.DeviceRouteSelector__noDisplay : ""}>
                        <button disabled={!selectedItem} onClick={()=>{
                            setRoutingInProgress(true);
                            onRoute(dispensingOrder, selectedItem.device);
                        }}>
                            {t("routeOrderButtonLabel")}
                        </button>
                    </div>
                    <div className={routingInProgress ? "" : styles.DeviceRouteSelector__noDisplay}>
                        <AntSpin
                            message="Processing, please be patient..."
                            containerStyle="container-001"
                            spinnerStyle="ant-spin-000"
                            messageStyle="message-001"
                            spinSize="large"
                        />
                    </div>
                </footer>
            </div>
        </div>
    )

}

export default DeviceRouteSelector;
